import type { SetupChecklistItem } from "@unbox/db";

// Dependency-light (db *types* only) so it can be re-exported from `@unbox/api`
// and consumed by the frontend without pulling the DB client into the bundle.

// The checklist items in display order. Keyed off the DB enum so adding an item
// is a compile error until it is listed here.
export const SETUP_CHECKLIST_ITEMS = [
  "risks",
  "policies",
  "tiktokAds",
  "allocations",
  "cohorts",
  "collabs",
  "outreach",
  "templates",
] as const satisfies readonly SetupChecklistItem[];

// The items no backend signal can detect, so a person confirms them by hand.
export const MANUAL_SETUP_CHECKLIST_ITEMS = ["risks", "policies"] as const satisfies readonly SetupChecklistItem[];

export type ManualSetupChecklistItem = (typeof MANUAL_SETUP_CHECKLIST_ITEMS)[number];

export const isManualSetupChecklistItem = (item: SetupChecklistItem): item is ManualSetupChecklistItem =>
  (MANUAL_SETUP_CHECKLIST_ITEMS as readonly SetupChecklistItem[]).includes(item);
